import React from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ButtonComponent';
import { Text } from '@/components/TextComponent';
import { Box } from '@/components/lib/components';
import { ds } from '@/components/lib/design.system';
import { DepositButton } from '@/feature/account-details/components/DepositButton';

import { useStartGameAction } from '../hooks/use-start-game-action';

export const PLAY_BAR_HEIGHT = 80;

export const PlayGameBar = () => {
    const { t } = useTranslation(['common', 'wallet', 'arcade_game_details']);

    const {
        handleStartGame,
        isLoading: isGameLoading,
        hasInsufficientRealMoney,
        hasInsufficientBetrBucks,
        isPractice,
    } = useStartGameAction();

    const playButton = (
        <Box px="s16" height={PLAY_BAR_HEIGHT} justifyContent="center">
            <Button
                hierarchy="primaryLilac"
                label={t('play')}
                disabled={isGameLoading}
                loading={isGameLoading}
                onPress={handleStartGame}
            />
        </Box>
    );

    if (isPractice) {
        return <>{playButton}</>;
    }

    return (
        <>
            {hasInsufficientRealMoney ? (
                <>
                    <Text variant="bodySmall" color={ds.colorToken.text.danger} textAlign={'center'}>
                        {t('entry_amount_exceeds_balance')}
                    </Text>
                    <Box px="s16" height={PLAY_BAR_HEIGHT} justifyContent="center">
                        <DepositButton buttonHierarchy="secondary" customLabel={t('wallet:deposit')} />
                    </Box>
                </>
            ) : hasInsufficientBetrBucks ? (
                <Box px="s16" height={PLAY_BAR_HEIGHT} justifyContent="center">
                    <Text variant="bodySmall2" color={ds.colorToken.text.danger} textAlign={'center'}>
                        {t('arcade_game_details:entry_amount_exceeds_betr_bucks_balance')}
                    </Text>
                </Box>
            ) : (
                playButton
            )}
        </>
    );
};
